import React from 'react';
import { roundNum } from 'utils/numbers';
import NutritionItem from './NutritionItem';

class NutritionList extends React.Component {
  render() {
    return (
      <ul className="nutrition-list">
        {this.props.plans &&
          this.props.plans.map(plan => {
            return (
              <li key={plan.id}>
                <NutritionItem
                  key={plan.id}
                  title={plan.name}
                  desc={`${roundNum(plan.meals_count)} Meals,${
                    Number(plan.snacks_count) > 0
                      ? ` ${roundNum(plan.snacks_count)} Snacks,`
                      : ''
                  } ${roundNum(plan.total_calories)} Cal`}
                  LinkTo={`/nutrition/${plan.id}`}
                />
              </li>
            );
          })}
      </ul>
    );
  }
}

export default NutritionList;
